// src/components/VersionBadge.tsx
import React from 'react';
import { BUILD_ID } from '@/config/build';

export function VersionBadge() {
  return (
    <div
      style={{
        position: 'fixed',
        right: 8,
        bottom: 8,
        padding: '4px 8px',
        background: 'rgba(0,0,0,.6)',
        color: '#fff',
        borderRadius: 6,
        fontSize: 12,
        zIndex: 99999,
        fontFamily: 'monospace',
      }}
    >
      BUILD: {BUILD_ID}
    </div>
  );
}
